"use client";
import { useEffect, useCallback } from "react";
import { createContext, useState } from "react";
import { GetCategories, GetGames, GetSubCategories } from "../services/games";
import { GetUserInfo } from "../services/user";
import { GetActiveCoupon, GetPlayerCoupons } from "../services/coupon";
import { GetCountries } from "../services/helper";
import { GetTournaments } from "../services/tournaments";

// Import za server-side slanje podataka na Customer.io
// const sendUserDataToCustomerIo = async (userData) => {
//   try {
//     const response = await fetch('/api/identifyUser', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(userData),
//     });

//     const data = await response.json();
//     console.log(data.message);
//   } catch (error) {
//     console.error('Error sending user data to Customer.io:', error);
//   }
// };

export const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [gamesCategories, setGamesCategories] = useState([]);
  const [gamesSubCategories, setGamesSubCategories] = useState([]);
  const [games, setGames] = useState([]);
  const [pageLoader, setPageLoader] = useState(true);
  const [isClosed, setIsClosed] = useState(true);
  const [link, setLink] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [isCouponOpen, setIsCouponOpen] = useState(false);
  const [activeCoupon, setActiveCoupon] = useState(null);
  const [isCouponActivated, setIsCouponActivated] = useState(false);
  const [paymentResponse, setPaymentResponse] = useState(null);
  const [errorMessagePayment, setErrorMessagePayment] = useState(null);
  const [countries, setCountries] = useState([]);
  const [adminMessage, setAdminMessage] = useState(null);
  const [isCDKLoggedIn, setIsCDKLoggedIn] = useState(false);
  const [playerCoupons, setPlayersCoupons] = useState([]);

  const [isMobile, setIsMobile] = useState(true);
  const [freeSpinGame, setFreeSpinGame] = useState(null);
  const [tournamentLink, setTournamentLink] = useState(null);

  const loadTawk = useCallback(
    () =>
    (Tawk_API.onLoad = function () {
      setIsTawkRedered(true);
    }),
    []
  );

  useEffect(() => {
    const handleResize = () => {
      const newIsMobile = window.innerWidth < 950;
      setIsMobile(newIsMobile);
    };

    window.addEventListener("resize", handleResize);

    const loadInitialData = async () => {
      try {

        const response = await Promise.allSettled([
          GetGames(),
          GetCategories(),
          GetSubCategories(),
          GetUserInfo(),
          GetActiveCoupon(),
          GetCountries(),
          CDK?.connect?.(
            CDK.ClientTypes.InstantPlay,
            "{4FFB2EEE-C103-4677-A006-53FCEDFCFAB3}",
            "LobbyCore"
          ),
        ]);


        const [
          gamesResult,
          categoriesResult,
          subCategoriesResult,
          userInfoResult,
          activeCouponResult,
          countriesResult,
        ] = response;

        if (gamesResult.status === "fulfilled" && Array.isArray(gamesResult.value)) {
          setGames(
            gamesResult.value.sort((a, b) =>
              a?.displayName?.localeCompare(b?.displayName)
            )
          );
        }

        if (categoriesResult.status === "fulfilled") {
          setGamesCategories(categoriesResult.value);
        }

        if (subCategoriesResult.status === "fulfilled" && Array.isArray(subCategoriesResult.value)) {
          setGamesSubCategories(
            subCategoriesResult.value.sort((a, b) =>
              a?.name?.localeCompare(b?.name)
            )
          );
        }

        if (userInfoResult.status === "fulfilled" && userInfoResult.value) {
          const user = userInfoResult.value;
          setUser(user);

          const userData = {
            email: user?.email,
            username: user?.username,
            country: user?.country,
            name: user?.name,
            birthDate: new Date(
              new Date(user?.birthDate).setFullYear(1973)
            ).toISOString().split("T")[0],
            lastLogin: new Date(user?.lastLogin).toISOString(),
            created: new Date(user?.created).toISOString(),
            lastActivity: user?.lastBet
              ? new Date(user?.lastBet).toISOString()
              : "-",
            lastDeposit: user?.lastDeposit
              ? new Date(user?.lastDeposit).toISOString()
              : "-",
            playerClass: user?.playerClass,
            gender: user?.gender,
            age: user?.age,
            totalDepositsCount: user?.totalDepositsCount,
            totalWithdrawalsCount: user?.totalWithdrawalsCount,
            totalDeposits: user?.totalDeposits,
            totalWithdrawals: user?.totalWithdrawals,
            yesterdayDeposit: user?.yestrdayDeposit,
          };

          // await sendUserDataToCustomerIo(userData);
        }

        if (
          activeCouponResult.status === "fulfilled" &&
          activeCouponResult.value !== 204
        ) {
          setActiveCoupon(activeCouponResult.value[0]);
          setIsCouponActivated(
            activeCouponResult.value[0]?.bank_method_list ? false : true
          );
        }

        if (countriesResult.status === "fulfilled") {
          setCountries(countriesResult.value);
        }

        const isConnected = await CDK?.isConnected?.();
        const rememberedUsername = await CDK?.getRememberedLogin?.();
        const rememberedPassword = await CDK?.getRememberedPassword?.();

        if (
          isConnected &&
          rememberedUsername === userInfoResult?.value?.username &&
          rememberedPassword?.length > 0
        ) {
          await CDK.logIn(
            rememberedUsername,
            rememberedPassword,
            true,
            true,
            true
          );

          const game = await CDK.getFreeSpinCouponInfo();
          if (game?.FreeSpinInfo?.Gameid && gamesResult?.value) {
            let findGame = gamesResult.value.find(
              (value) =>
                value?.gameId === game?.FreeSpinInfo?.Gameid &&
                value?.machineId === game?.FreeSpinInfo?.Machid
            );
            if (findGame) {
              findGame = {
                ...findGame,
                remainingSpins: game?.FreeSpinInfo?.SpinsRemaining,
              };
              setFreeSpinGame(findGame);
              const el = document.getElementById("idFreeSpin");
              if (el) el.style.display = "block";
            }
          }

          const isLoggedIn = await CDK.isLoggedIn?.();
          setIsCDKLoggedIn(isLoggedIn);
        }
      } catch (error) {
        console.error("❌ Greška u loadInitialData:", error);
      } finally {
        setPageLoader(false);
      }
    };

    loadInitialData();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const cdkEvents = async () => {
    CDK.on(CDK.Events.balancesChanged, async function (msg) {
      const balance = await CDK.getBalances();
      setUser((current) => ({
        ...current,
        balance: balance?.Balance ?? current?.balance,
        bonusBalance: balance?.BonusBalance ?? current?.bonusBalance,
        compPoints: balance?.CompPoints ?? current?.compPoints,
        withdrawableBalance:
          balance?.WithdrawableBalance ?? current?.withdrawableBalance,
        playthroughBalance:
          balance?.PlaythroughBalance ?? current?.playthroughBalance,
      }));
    }).on(CDK.Events.sessionChanged, async (msg) => {
      await CDK.tryRestoreLastSession();
    });
    CDK.getLobbyHub().on(
      CDK.Events.adminPlayerMessagesReceived,
      function (msg) {
        document.getElementById("idAdminMessages").style.display = "block";
        setAdminMessage(msg[0]?.Message ?? null);
      }
    );
  };

  useEffect(() => {
    if (user) {
      loadTawk();
    }
  }, [user]);

  useEffect(() => {
    if (user && isCDKLoggedIn) {
      cdkEvents();
    }
  }, [user, isCDKLoggedIn]);

  const values = {
    user,
    setUser,
    gamesCategories,
    setGamesCategories,
    gamesSubCategories,
    setGamesSubCategories,
    games,
    setGames,
    pageLoader,
    setPageLoader,
    isClosed,
    setIsClosed,
    isMobile,
    link,
    setLink,
    openModal,
    setOpenModal,
    isCouponOpen,
    setIsCouponOpen,
    activeCoupon,
    setActiveCoupon,
    isCouponActivated,
    setIsCouponActivated,
    countries,
    setCountries,
    paymentResponse,
    setPaymentResponse,
    errorMessagePayment,
    setErrorMessagePayment,
    adminMessage,
    setAdminMessage,
    freeSpinGame,
    setFreeSpinGame,
    tournamentLink,
    setTournamentLink,
    playerCoupons,
    setPlayersCoupons,
  };

  return <AppContext.Provider value={values}>{children}</AppContext.Provider>;
};